import { type VariantProps, cva } from "class-variance-authority";
import { type ComponentPropsWithoutRef, type ComponentRef, type ReactElement, forwardRef } from "react";

import styles from "./icon-button.module.scss";

const iconButtonStyles = cva(styles.button, {
  variants: {
    variant: {
      primary: styles.primary,
      neutral: styles.neutral,
    },
    size: {
      sm: styles.sm,
      md: styles.md,
    },
  },
  defaultVariants: {
    variant: "primary",
    size: "md",
  },
});

export type VariantPropsT = VariantProps<typeof iconButtonStyles>;

export type IconButtonT = Omit<ComponentPropsWithoutRef<"button">, "disabled" | "children"> & {
  "aria-label": string;
  icon: ReactElement;
  isDisabled?: boolean;
} & VariantPropsT;

export const IconButton = forwardRef<ComponentRef<"button">, IconButtonT>(function IconButton(
  { icon, "aria-label": label, className, isDisabled, variant, size, type, ...props },
  ref
) {
  return (
    <button
      {...props}
      type={type}
      ref={ref}
      aria-label={label}
      className={iconButtonStyles({ variant, size, className })}
      disabled={isDisabled}
    >
      {icon}
    </button>
  );
});
